export const keysServicesPtBr = {
  'services.mymdm.title': 'MyMDM',
  'services.mymdm.titlePartial': 'MDM',
  'services.mymdm.subtitle': 'Plataforma de monitoramento e gestão de terminais',
  'services.mymdm.monitoring': 'Monitoramento remoto dos terminais em tempo real através de diversos dashboards',
  'services.mymdm.monitoringPartial': 'Monitoramento',
  'services.mymdm.settings':
    'Configuração remota e a opção de habilitar ou desabilitar as funções de configuração do terminal',
  'services.mymdm.settingsPartial': 'Configuração remota',
  'services.mymdm.custom': 'Personalização remota do launcher e opções de acesso aos aplicativos',
  'services.mymdm.customPartial': 'Personalização remota do launcher',
  'services.mymdm.install': 'Instalação e atualização remota dos aplicativos',
  'services.mymdm.installPartial': 'Instalação e atualização remota',
  'services.mymdm.access': 'Acesso ao robô de assinatura 24x7',
  'services.mymdm.accessPartial1': 'Acesso',
  'services.mymdm.accessPartial2': '24x7',
  'services.mymdm.apps': 'Gerencie app e versões disponíveis para seus usuários',
  'services.mymdm.appsPartial': 'Gerencie app e versões',
  'services.mymdm.support': 'Suporte Remoto disponível por dispositivo e usuário',
  'services.mymdm.supportPartial': 'Suporte Remoto',
  'services.mymdm.panel': 'Crie painéis e relatórios customizados para análise de dados conforme seu interesse ',
  'services.mymdm.panelPartial': 'Crie painéis e relatórios customizados',
  'services.mymdm.cost': 'Reduza o custo operacional com instalações, atendimento e incidentes de suporte',
  'services.mymdm.costPartial': 'Reduza o custo',
  'services.mymdm.increase':
    'Aumente a disponibilidade de uso e garantir a alta performance do terminal através do monitoramento preventivo e de atualizações programadas',
  'services.mymdm.increasePartial': 'Aumente',

  'services.mymdm.footerDescription':
    'O MyMDM é uma ferramenta completa que possibilita ao cliente ou parceiro a gestão remota da sua base de terminais, incluindo os recursos de monitoramento e configuração dos terminais e a distribuição ou atualização dos aplicativos pelo próprio MyMDM ou por meio da Smart Store.',
  'services.mymdm.footerDescriptionPartial1': 'MyMDM',
  'services.mymdm.footerDescriptionPartial2': 'Smart Store',
  'services.mymdm.footerActionButton': 'Tenho interesse',

  'services.mynps.title': 'MyNPS',
  'services.mynps.subtitle': 'Pesquisa de satisfação no formato Net Promoter Score',
  'services.mynps.footerDescription':
    'O MyNPS é uma plataforma completa que pode funcionar integrada a outros PINPADs Gertec para a coleta das informações no ato da venda. Os dados são capturados no formato NPS (Net Promoter Score), e podem ser integrados aos sistemas de automação ou retaguarda através das APIs da plataforma.',
  'services.mynps.footerDescriptionPartial': 'MyNPS',
  'services.mynps.benefit.cloud': 'Solução 100% Cloud;',
  'services.mynps.benefit.cloudPartial': 'Solução 100% Cloud',
  'services.mynps.benefit.pinpad': 'Integração com PINPAD Gertec;',
  'services.mynps.benefit.pinpadPartial': 'Integração com PINPAD Gertec',
  'services.mynps.benefit.commercialAutomation': 'Integração com automação comercial;',
  'services.mynps.benefit.commercialAutomationPartial': 'Integração com automação comercial',
  'services.mynps.benefit.noHardware': 'Funcionamento sem hardware adicional;',
  'services.mynps.benefit.noHardwarePartial': 'sem hardware adicional',
  'services.mynps.benefit.dashboards': 'Diversos dashboards e relatórios;',
  'services.mynps.benefit.dashboardsPartial': 'dashboards e relatórios',
  'services.mynps.benefit.npsFormat': 'Disponibilidade no formato NPS.',
  'services.mynps.benefit.npsFormatPartial': 'formato NPS',
  'services.mynps.footerActionButton': 'Tenho interesse'
};
